// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EmtOx","avatar":"styles_avatar__NDWcB","avatarComp":"styles_avatarComp__wVWh2","plus":"styles_plus__m86An","noFriend":"styles_noFriend__fQlVy"};